import { ActionType } from "PFApp/hooks/activity_form/multi_roles_form/use_actions_column";
import { EngagementRef, Id } from "PFTypes";

export enum ManageRolesActionType {
  EditAvailability = ActionType.EditAvailability,
  Publish = "publish",
  FillAndBook = "fill_and_book"
}

export type ManageRolesTableDataItem = {
  uniqueId: string;
  disabled: boolean;
  engagement: EngagementRef | undefined;
  activityId?: Id;
};
